//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../passwordRecoveryModule.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import FormTextField from 'app_components/commons/FormTextField/FormTextField';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';

// @ADD Component types
interface IPasswordRecoveryModuleLayoutProps {
  onGoBack?: () => void
  onSubmit: (data: any) => any,
  status: "loading" | "error" | null
  stage: number
}

const PasswordRecoveryModuleLayout: React.FC<IPasswordRecoveryModuleLayoutProps> = (props) => {

  const password = React.useRef({});
  const { t } = useTranslation()
  const formHook = useForm()

  password.current = formHook.watch("password", "");

  return(
    <div className='password_recovery_module-component'>
      {props.stage === 1 && (
        <>
          <TextComponent color="#545C61" marginBottom={10}>{t("modules.password_recovery.stage_send_code.content")}</TextComponent>

          <form className='password-recovery--form' onSubmit={formHook.handleSubmit(props.onSubmit)}>
            <FormTextField
              control={formHook.control}
              id="email"
              error={formHook.errors?.email}
              errorText="Este campo es requerido"
              label='Correo'
            />

            <div className="password-recovery--actions">
              <ButtonComponent
                border='1px solid var(--secondary)'
                color='var(--secondary)'
                textTransform='initial'
                paddingTop={11}
                paddingBottom={11}
                fontSize={18}
                onClick={props.onGoBack}
              >
                Atras
              </ButtonComponent>
              <ButtonComponent
                variant='secondary'
                textTransform='initial'
                paddingTop={12}
                paddingBottom={12}
                fontSize={18}
                type="submit"
              >
                Recuperar
              </ButtonComponent>
            </div>
          </form>
        </>
      )}
      {props.stage === 2 && (
        <>
          <TextComponent color="#545C61" marginBottom={10}>{t("modules.password_recovery.stage_change_pass.content")}</TextComponent>

          <form className='password-recovery--form' onSubmit={formHook.handleSubmit(props.onSubmit)}>
            <FormTextField
              control={formHook.control}
              id="code"
              error={formHook.errors?.code}
              errorText="Este campo es requerido"
              label='Código'
              placeholder='Ej: 12345'
              required
            />

            <FormTextField
              control={formHook.control}
              id="password"
              type="password"
              error={formHook.errors?.password}
              errorText="Este campo es requerido"
              label='Nueva contraseña'
              placeholder='Ingresa tu contraseña'
              required
            />

            <FormTextField
              control={formHook.control}
              id="passwordConfirm"
              type="password"
              error={formHook.errors?.passwordConfirm}
              label='Confirma tu contraseña'
              placeholder='Confirma tu contraseña'
              required
              validate={(value) => {
                if (formHook.watch('password') !== value) {
                  return "Las contraseñas no coinciden"
                }
              }}
            />

            <div className="password-recovery--actions">
              <ButtonComponent
                border='1px solid var(--secondary)'
                color='var(--secondary)'
                textTransform='initial'
                paddingTop={11}
                paddingBottom={11}
                fontSize={18}
                onClick={props.onGoBack}
              >
                Cancelar
              </ButtonComponent>
              <ButtonComponent
                variant='secondary'
                textTransform='initial'
                paddingTop={12}
                paddingBottom={12}
                fontSize={18}
                type="submit"
              >
                Cambiar contraseña
              </ButtonComponent>
            </div>
          </form>
        </>
      )}
    </div>
  )
}

export default PasswordRecoveryModuleLayout
